import { connect } from 'react-redux'
import Toolbar from '../../components/calendar/toolbar'

const mapStateToProps = (state, ownProps) => {
  const {
    locationId = null,
    areaId = null,
    technicianId = null,
    serviceIds = null,
  } = state.calendarFilters

  return {
    locationId,
    areaId,
    technicianId,
    serviceIds,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Toolbar)



// WEBPACK FOOTER //
// ./src/containers/calendar/toolbar-container.js